import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FunctionField,
  Datagrid,
  DateField,
  Filter,
  List,
  ListProps,
  NumberField,
  SelectInput,
  TopToolbar,
} from 'react-admin';
import { Button, Card, CardContent, Typography, CircularProgress } from '@material-ui/core';

import { UserSelfApplyAllocateModal } from './UserSelfApplyAllocateModal';
import { fetchProvidersRequest } from './actions';

const ProviderFilter: React.FC<any> = (props) => {
  const providers = useSelector((state: any) => state?.userSelfApply?.providers?.data || []);
  const choices = providers.map((p: any) => ({ id: String(p.id), name: p.name }));
  return (
    <Filter {...props}>
      <SelectInput
        alwaysOn
        choices={choices}
        label="Provider"
        optionText="name"
        optionValue="id"
        source="providerId"
      />
    </Filter>
  );
};

export const UserSelfApplyList = (props: ListProps) => {
  const [open, setOpen] = useState(false);
  const onSuccess = useCallback(() => {}, []);
  const dispatch = useDispatch();
  const providers = useSelector((state: any) => state?.userSelfApply?.providers?.data || []);
  const loading = useSelector((state: any) => state?.userSelfApply?.allocateRequest?.loading);
  const providersMap = useMemo(() => {
    const map: Record<number, string> = {};
    for (const p of providers) map[p.id] = p.name;
    return map;
  }, [providers]);

  useEffect(() => {
    dispatch(fetchProvidersRequest());
  }, [dispatch]);

  return (
    <>
      <TopToolbar>
        {loading && (
          <Card>
            <CardContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CircularProgress />
              <Typography style={{ marginLeft: '16px', marginRight: '16px' }}>Loading User Self Applies...</Typography>
            </CardContent>
          </Card>
        ) || ( 
          <Button
            color="primary"
            variant="contained"
            onClick={() => setOpen(true)}
          >
            Bulk create
          </Button>
        )}
        
      </TopToolbar>
      <List
        filters={<ProviderFilter />}
        {...props}
        perPage={25}
        resource="admin/userSelfApply"
        sort={{ field: 'id', order: 'desc' }}
      >
        <Datagrid rowClick="toggleSelection">
          <NumberField source="id" />
          <DateField source="dateOf" />
          <NumberField source="appliedCount" />
          <FunctionField
            label="Provider"
            render={(record: any) => providersMap[record.providerId] || record.providerId}
          />
          <DateField source="createdAt" />
        </Datagrid>
      </List>
      <UserSelfApplyAllocateModal
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={onSuccess}
      />
    </>
  );
};


